/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface EnumerationEvaluationResultDto
 */
export interface EnumerationEvaluationResultDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    evaluationParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    name?: string | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof EnumerationEvaluationResultDto
     */
    evaluationOutcome?: EvaluationState;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationEvaluationResultDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof EnumerationEvaluationResultDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof EnumerationEvaluationResultDto
     */
    lastModifierUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    dataSetId?: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof EnumerationEvaluationResultDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {EnumerationOptionDto}
     * @memberof EnumerationEvaluationResultDto
     */
    selectedOption?: EnumerationOptionDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    $type?: EnumerationEvaluationResultDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationEvaluationResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoEnumerationEvaluationResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.EnumerationEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationEvaluationResultDtoTypeEnum = typeof EnumerationEvaluationResultDtoTypeEnum[keyof typeof EnumerationEvaluationResultDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationEvaluationResultDto interface.
 */
export function instanceOfEnumerationEvaluationResultDto(value?: unknown): value is EnumerationEvaluationResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationEvaluationResultDtoTypeEnum)[0];
}

export function EnumerationEvaluationResultDtoFromJSON(json: any): EnumerationEvaluationResultDto {
    return EnumerationEvaluationResultDtoFromJSONTyped(json, false);
}

export function EnumerationEvaluationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationEvaluationResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'evaluationParameterId': !exists(json, 'evaluationParameterId') ? undefined : json['evaluationParameterId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'evaluationOutcome': !exists(json, 'evaluationOutcome') ? undefined : EvaluationStateFromJSON(json['evaluationOutcome']),
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['lastModifierUser']),
        'dataSetId': !exists(json, 'dataSetId') ? undefined : json['dataSetId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'selectedOption': !exists(json, 'selectedOption') ? undefined : EnumerationOptionDtoFromJSON(json['selectedOption']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationEvaluationResultDtoToJSON(value?: EnumerationEvaluationResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'evaluationParameterId': value.evaluationParameterId,
        'name': value.name,
        'evaluationOutcome': EvaluationStateToJSON(value.evaluationOutcome),
        'origin': EntityOriginToJSON(value.origin),
        'iuid': value.iuid,
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.creatorUser),
        'lastModifierUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.lastModifierUser),
        'dataSetId': value.dataSetId,
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'selectedOption': EnumerationOptionDtoToJSON(value.selectedOption),
        '$type': value.$type,
    });
}

